import React from 'react';

/*
 * Anteprima della scheda della struttura come la vede chi apre l'app SportID Player, nei tre stili.
 * Ricostruita da `struttura_scheda_templates.dart` dell'app (misure ridotte a ~75%), con dati di esempio:
 * non usa i dati della struttura. Se cambia la scheda nell'app, va aggiornata qui.
 */

const ESEMPIO = {
    nome: 'Tennis Club Aurora',
    sottotitolo: 'Circolo sportivo',
    indirizzo: 'Via Roma 12, Bologna',
    sport: ['Tennis', 'Padel', 'Nuoto'],
    soci: 128,
    maestri: 6,
    campi: 8,
};

/* Foto di esempio: sfumature, niente immagini esterne */
const FOTO = [
    'linear-gradient(135deg, #2F6F4E 0%, #5FAE82 55%, #A8D5BA 100%)',
    'linear-gradient(135deg, #C0623B 0%, #E39A6B 100%)',
    'linear-gradient(135deg, #2D5E8C 0%, #6FA3CF 100%)',
];

const Foto = ({ i, className = '', children }) => (
    <div className={`sid-ante__foto ${className}`} style={{ background: FOTO[i % FOTO.length] }}>{children}</div>
);

const Indietro = () => <span className="sid-ante__indietro">‹</span>;
const BarraTitolo = () => <div className="sid-ante__barra"><span>‹</span><strong>STRUTTURA</strong></div>;
const Chips = () => (
    <div className="sid-ante__chips">{ESEMPIO.sport.map((s) => <span key={s}>{s}</span>)}</div>
);

const Stile1 = ({ soci }) => (
    <>
        <div className="sid-ante__copertina">
            <Foto i={0} className="sid-ante__foto--piena" />
            <Indietro />
            <span className="sid-ante__conta">5 foto</span>
            <div className="sid-ante__logo">TA</div>
        </div>
        <div className="sid-ante__corpo sid-ante__corpo--logo">
            <div className="sid-ante__nome">{ESEMPIO.nome}</div>
            <div className="sid-ante__muto">{ESEMPIO.sottotitolo} · {ESEMPIO.indirizzo}</div>
            <Chips />
            <div className="sid-ante__muto">{soci ? `${ESEMPIO.soci} soci · ` : ''}{ESEMPIO.maestri} maestri</div>
        </div>
    </>
);

const Stile2 = ({ soci }) => {
    const numeri = [...(soci ? [[ESEMPIO.soci, 'Soci']] : []), [ESEMPIO.maestri, 'Maestri'], [ESEMPIO.campi, 'Campi']];
    return (
        <>
            <BarraTitolo />
            <div className="sid-ante__corpo sid-ante__corpo--piccolo">
                <div className="sid-ante__mosaico">
                    <Foto i={0} className="sid-ante__mosaico-grande" />
                    <div className="sid-ante__mosaico-lato">
                        <Foto i={1} />
                        <Foto i={2}>
                            <span className="sid-ante__piu">+2 foto</span>
                            <span className="sid-ante__video">▶ Video</span>
                        </Foto>
                    </div>
                </div>
                <div className="sid-ante__nome sid-ante__nome--b">{ESEMPIO.nome}</div>
                <Chips />
                <div className="sid-ante__muto">{ESEMPIO.sottotitolo} · {ESEMPIO.indirizzo}</div>
                <div className="sid-ante__numeri">
                    {numeri.map(([n, e]) => <div key={e}><b>{n}</b><span>{e}</span></div>)}
                </div>
                <div className="sid-ante__azioni">
                    <span>Chiama</span><span>Indicazioni</span><span>Sito</span>
                </div>
            </div>
        </>
    );
};

const Stile3 = ({ soci }) => (
    <>
        <BarraTitolo />
        <div className="sid-ante__corpo sid-ante__corpo--piccolo">
            <div className="sid-ante__testata">
                <Foto i={0} className="sid-ante__tondo" />
                <div>
                    <div className="sid-ante__nome sid-ante__nome--c">{ESEMPIO.nome}</div>
                    <div className="sid-ante__muto">{ESEMPIO.sottotitolo} · {ESEMPIO.indirizzo}</div>
                    <div className="sid-ante__muto">{soci ? `${ESEMPIO.soci} soci · ` : ''}{ESEMPIO.maestri} maestri</div>
                </div>
            </div>
            <div className="sid-ante__sport">
                {[['🎾', 'Tennis'], ['🏸', 'Padel'], ['🏊', 'Nuoto']].map(([e, n]) => (
                    <div key={n}><span>{e}</span>{n}</div>
                ))}
            </div>
        </div>
    </>
);

export const AnteprimaScheda = ({ stile, soci = true }) => (
    <div className="sid-ante" aria-hidden="true">
        {stile === 1 && <Stile1 soci={soci} />}
        {stile === 2 && <Stile2 soci={soci} />}
        {stile === 3 && <Stile3 soci={soci} />}
    </div>
);

export default AnteprimaScheda;
